import React from "react";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import { MediaSlotSerializer } from "web/types/serializers";
import * as styles from "./shopfront-media-slot.css";

export interface ShopfrontMediaSlotProps {
    slot: MediaSlotSerializer;
    ctaLabel?: string;
}

export function ShopfrontMediaSlot({
    slot,
    ctaLabel,
}: ShopfrontMediaSlotProps): React.ReactElement | null {
    if (!slot.image_url) {
        return null;
    }

    const image = <img src={slot.image_url} alt="" className={styles.image} />;

    if (!slot.link_url) {
        return <div className={styles.container}>{image}</div>;
    }

    return (
        <a href={slot.link_url} className={styles.container}>
            {image}
            {slot.caption && (
                <span className={styles.captionContainer}>
                    <Text textStyle="body-xs-bold" as="span">
                        {slot.caption}
                    </Text>
                    <Text textStyle="body-xs" as="span" className={styles.exploreLink}>
                        {ctaLabel ?? gettext("shopfront.media_slot.explore")}
                    </Text>
                </span>
            )}
        </a>
    );
}
